import axios from 'axios';

class DemoViewMagicLinkLogin {
    public login(token: string) {
        return axios.post(`/auth/demoLogin/${token}`);
    }
}

export const demoViewMagicLogin = new DemoViewMagicLinkLogin();
